export default __webpack_public_path__ + "static/media/img-step-2.7038b0d9.png";